/***
 * 创建人：yjs
 * 时间：2019-05-23
 * 描述：进行重复性验证,所选上级不能与自身重复
 * 更新记录: 
 */
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validatorEqual]',
  providers:[{provide:NG_VALIDATORS,useExisting:forwardRef(()=>ValidatorEqualDirective),multi:true}]
})
export class ValidatorEqualDirective {

  constructor() { }
  validate(control:AbstractControl):any{
    let modalData = control['_parent']['value']
    let position1 = modalData.levelId;  //自身的id,从input['type=hidden']中获取,所有需要手动添加<input type="text" [(ngModel)]="" name="levelId" hidden>
    let position2 = control.value;  //所选的上级的id
    let valid:boolean = false
    if(position1 && position2){
      valid = (position1 == position2)
    }
    return valid ? {equal:true} : null
  }
}
